import React, { useMemo } from "react";
import {
  Typography,
  List,
  Link,
  ListItem,
  ListItemText,
  Divider,
  Box,
  ListItemButton,
  ListItemIcon,
  Card,
  CardContent,
} from "@mui/material";
import { Link as LinkBase } from "react-router-dom";
import PushPinIcon from "@mui/icons-material/PushPin";
import { CircleBackground } from "./styles";
import { CoachRoutes } from "config/routes";
import { Resource } from "types/resource";

type QuickAccessProps = {
  data: any;
};

export const QuickAccess: React.FC<QuickAccessProps> = ({ data }) => {
  const resources = useMemo<Resource[]>(() => {
    if (data) {
      const resourcesData = data.resources;

      const filteredResourcesData = Array.from(
        new Map(
          resourcesData?.map((resource: Resource) => [
            resource.resource_id,
            resource,
          ]),
        ).values(),
      ) as Resource[];
      return filteredResourcesData || [];
    }

    return [];
  }, [data]);

  if (resources.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" gutterBottom>
            Quick Access
          </Typography>
        </Box>

        <List>
          {resources?.map((resource, index) => (
            <React.Fragment key={resource.name}>
              <ListItem sx={{ padding: 0 }}>
                <ListItemButton
                  component={LinkBase}
                  to={resource.url}
                  sx={{ padding: 0 }}
                  target="_blank"
                >
                  <ListItemIcon
                    sx={{ textAlign: "center", justifyContent: "space-around" }}
                  >
                    <CircleBackground>
                      <PushPinIcon
                        fontSize="small"
                        sx={{ verticalAlign: "sub" }}
                      />
                    </CircleBackground>
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography variant="subtitle1" fontWeight="bold">
                        {resource.name}
                      </Typography>
                    }
                    secondary={
                      resource.description.length > 64
                        ? resource.description.slice(0, 64) + "..."
                        : resource.description
                    }
                  />
                </ListItemButton>
              </ListItem>
              {index < 2 && <Divider />}
            </React.Fragment>
          ))}
        </List>

        <Box mt={2}>
          <Link
            component={LinkBase}
            variant="body2"
            to="/resources"
            sx={{ textDecoration: "none" }}
          >
            View All Resources
          </Link>
        </Box>
      </CardContent>
    </Card>
  );
};
